import { i18nKeys } from 'translationTypes'
import { NccLinkPageConfig } from '.'

export const NZ_NCC_APPLICANT_URL = 'https://doordashnz.nationalcrimecheck.nz'

export const NZ_NCC_LINK_PAGE_CONFIG: NccLinkPageConfig = {
  docStringKeys: [
    i18nKeys.backgroundCheck__nccDocument__nz__passport,
    i18nKeys.backgroundCheck__nccDocument__dl,
    i18nKeys.backgroundCheck__nccDocument__creditOrBankCard,
  ],
  linkConfig: {
    startUrl: `${NZ_NCC_APPLICANT_URL}/consumer/start_form`,
    hasEncodedClientRef: false,
  },
}
